module.exports = __webpack_public_path__ + "static/media/frontphone-newsletter-small.cb513d77.png";